<template>
    <div class="codics-aonaer-info-sys-user-record-body">
        <el-drawer title="商品核销" :visible.sync="qrDialog" :append-to-body="true" :modal-append-to-body="false"
            direction="btt" size="calc(100% - 60px)">
            <el-image class="codics-aonaer-info-sys-user-record-qrimg" :src="qrImg" fit="fill"></el-image>
        </el-drawer>
        <div class="codics-aonaer-info-sys-user-record-title">兑换记录</div>
        <el-table :data="recordData" border
            style="width: 100%;position: relative;float:left;margin-top: 20px !important;margin-bottom: 30px !important;">
            <el-table-column prop="product.himg" label="商品图片" width="180">
                <template slot-scope="scope">
                    <el-image :src="initHimg(scope.row.product.img)" fit="fill"></el-image>
                </template>
            </el-table-column>
            <el-table-column prop="product.name" label="商品名称" width="180">
            </el-table-column>
            <el-table-column prop="ctime" label="兑换时间" width="180">
            </el-table-column>
            <el-table-column prop="points" label="积分明细">
                <template slot-scope="scope">
                    <span style="color: #ea5b18;font-weight: bolder;">-{{ scope.row.product.price }}</span>
                </template>
            </el-table-column>
            <el-table-column align="right" label="当前状态" min-width="150">
                <template slot-scope="scope">
                    <el-button :disabled="scope.row.state != 0" size="mini" style="margin-right: 10px;"
                        :type="['info', 'primary', ''][scope.row.state]" plain @click="hexClick(scope)">{{
            ['去核销', '待发货', '查询物流', '已冻结', '已封禁', '已核销', "已取消"][scope.row.state] }}</el-button>
                    <el-popconfirm title="您确定要取消当前订单吗？" @confirm="cancelOrderFuc(scope);">
                        <el-button v-show="scope.row.state == 0" size="mini" slot="reference" type="info"
                            plain>取消订单</el-button>
                    </el-popconfirm>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
import { getOrderList, cancelOrder } from '@/api';
import QRCode from 'qrcode';
export default {
    data() {
        return {
            qrDialog: false,
            qrImg: '',
            recordData: []
        }
    },
    mounted() {
        this.getOrderListFuc();
    },
    methods: {
        async cancelOrderFuc(scope) {
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            let data = await cancelOrder({ id: scope.row.id });
            loading.close();
            if (data.code == 200) {
                this.$message({
                    message: '订单取消成功！',
                    type: 'success'
                });
                setTimeout(() => {
                    window.location.reload();
                }, 300);
            } else {
                this.$message.error(data.message);
            }
        },
        async creatQrCode(QRlink) {   // QRlink是二维码的内容
            let _this = this;
            let opts = {
                errorCorrectionLevel: "L",//容错级别
                type: "image/png",//生成的二维码类型
                quality: 0.3,//二维码质量
                margin: 1,//二维码留白边距
                width: 100,//宽
                height: 100,//高
                text: QRlink,//二维码内容
                color: {
                    dark: "#000",//前景色
                    light: "#fff"//背景色
                }
            };
            await QRCode.toDataURL(QRlink, opts, (err, url) => {
                if (err) throw err
                //将生成的二维码路径复制给data的QRImgUrl
                // console.log(url)
                _this.qrImg = url;
            })
        },
        hexClick(scope) {

            this.creatQrCode('https://aonaer.katihuo.com/sign/' + scope.row.id);

            this.qrDialog = true;

        },
        initHimg(str) {

            return 'https://cdn.bosscaigou.com/' + str.split(',')[0];

        },
        async getOrderListFuc() {

            let data = await getOrderList();

            if (data.code == 200) {

                this.recordData = data.data.reverse();

            } else {

                this.$message.error(data.message);

            }

        }
    }
}
</script>

<style>
.codics-aonaer-info-sys-user-record-body {
    height: fit-content;
    min-height: 470px;
    width: 100%;
    position: relative;
    float: left;
    background: #FFF;
    padding: 0 30px;
    box-sizing: border-box;
}

.codics-aonaer-info-sys-user-record-title {
    height: 70px;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    font-size: 22px;
    font-weight: bold;
    color: #333;
    line-height: 90px;
}

.codics-aonaer-info-sys-user-record-title::before {
    content: '';
    height: 2px;
    width: 60px;
    position: absolute;
    margin: auto;
    left: 16px;
    bottom: 0;
    background: #ea5b18;
    border-radius: 1px;
}



.codics-aonaer-info-sys-user-record-qrimg {
    height: 150px;
    width: 150px;
    position: absolute !important;
    margin: auto;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
}
</style>